const container = document.getElementById('quick-estimate');
const productGids = JSON.parse(container.dataset.productGids);

const query = `
  query ($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Metaobject {
        id
        fields {
          key
          value
        }
      }
    }
  }
`;

fetch('/api/2024-10/graphql.json', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': '你的token'
  },
  body: JSON.stringify({
    query,
    variables: { ids: productGids }
  })
})
.then(res => res.json())
.then(({ data }) => {
  const products = data.nodes.map(node => {
    const obj = {};
    node.fields.forEach(f => obj[f.key] = f.value);
    return obj;
  });

  console.log('产品元对象：', products);
});
